// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"StoryDescription__paragraph--3_w3A","bounce":"StoryDescription__bounce--9mg6F"};